module.exports = __webpack_public_path__ + "img/face-angry.74b49a4f.svg";